const { createSelector } = require('reselect');

export const selectApplications = createSelector(
	state => state.main,
	main => main.applications
);

/** Product-data flags for the viewed company; null while still unresolved. */
export const selectCompanyProducts = createSelector(
	state => state.main,
	main => main.companyProducts
);
